<div *ngIf="jobcard.customer?.ID" class="customer-details-container">
    <div class="customer-header">
        <div>{{jobcard.customer.Name}} {{jobcard.customer.Surname}}</div>
        <div class="actions">
            <hub-button [icon]="'pencil'" [style]="'borderless-secondary'" [size]="'lg'"
                (buttonClick)="updateCustomer(jobcard.customer)" [disabled]="groupBookings || jobcard.customer?.Locked"></hub-button>
            <hub-button [icon]="'cross'" [style]="'borderless-secondary'" [size]="'lg'"
                (buttonClick)="clearCustomer()" [disabled]="groupBookings || jobcard.customer?.Locked"></hub-button>
        </div>
    </div>

    <div class="customer-details">
        <div *ngIf="jobcard.customer?.PhoneNumber">
            <div class="customer-detail">
                <div><daz-icon [name]="'phone-alt-1'" [size]="'24px'" [color]="'#6D6D6D'"></daz-icon></div>
                <div>
                    <div>{{'bikeshop.switch_shop.phone_number' | translate }}</div>
                    <div>{{jobcard.customer.PhoneNumber}}</div>
                </div>
            </div>
        </div>
        <div *ngIf="jobcard.customer?.Email">
            <div class="customer-detail">
                <div><daz-icon [name]="'mail-alt-1'" [size]="'24px'" [color]="'#6D6D6D'"></daz-icon></div>
                <div>
                    <div>{{'onboarding.email' | translate }}</div>
                    <div>{{jobcard.customer.Email}}</div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <div *ngIf="jobcard.customer?.ID" class="margin-top-16">
    <div *ngIf="!jobcard.clientNotes">
        <hub-button [icon]="'plus'" [style]="'borderless-secondary'" [size]="'sm'"
            text="{{'bikeshop.workshop.jobcard.customer.add_booking_notes' | translate }}"
            (buttonClick)="addBookingNotes()"></hub-button>
    </div>
    <div *ngIf="jobcard.clientNotes">
        <div class="booking-notes-header">{{ 'bikeshop.workshop.jobcard.customer.booking_notes' | translate }}</div>
        <div class="booking-notes-container">
            <div>{{jobcard.clientNotes}}</div>
            <div class="actions">
                <hub-button [icon]="'pencil'" [style]="'borderless-secondary'" [size]="'lg'"
                    (buttonClick)="addBookingNotes()"></hub-button>
                <hub-button [icon]="'cross'" [style]="'borderless-secondary'" [size]="'lg'"
                    (buttonClick)="clearBookingNotes()"></hub-button>
            </div>
        </div>
    </div>
</div> -->